import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditCustomerComponent } from '@app/core/windows'; 


@Component({
  selector: 'customers-crud',
  templateUrl: './customers-crud.component.html',
  providers: [ DatasourceService ]
})
export class CustomersCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditCustomerComponent, {static: false}) window !: CreateEditCustomerComponent;

  protected menu: string = 'Crédito';

  protected menuIcon: string = 'dollar';
  
  protected label: string = 'Cliente';

  protected name: string = 'Clientes';

  protected table: string = 'customers';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  public onCellClick(e: any): void {
      
    console.log(e);
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();
      // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
      // this.menu_ser.contextItem = e.dataItem;
      // this.menu_ser.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    }

  }

  public selectMenu({ menu, contextItem }): void {
    
    // console.log("selectMenu", menu, contextItem);

    if (menu.url === 'editar') {

      this.window.label = this.label;
      this.window.table = this.table;
      this.window.edit(contextItem);

    } else if (menu.url === 'eliminar') {
        
      this.removeHandler({dataItem: contextItem});

    }

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}